import { render, staticRenderFns } from "./ReelRemindersTable.vue?vue&type=template&id=c7d77588&"
import script from "./ReelRemindersTable.vue?vue&type=script&lang=js&"
export * from "./ReelRemindersTable.vue?vue&type=script&lang=js&"
import style0 from "./ReelRemindersTable.vue?vue&type=style&index=0&id=c7d77588&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports